export default __webpack_public_path__ + "open-padlock-silhouette.png";